// extracted by mini-css-extract-plugin
module.exports = {"container":"GoldPartners_container__3zbrg","headingContainer":"GoldPartners_headingContainer__3kJi0","partners":"GoldPartners_partners__3GGp9"};